module.exports = __webpack_public_path__ + "static/sec-mark-1d7220b3b79712d1660ce4b65a7a0842.png";